import Vue from 'vue';
import Vuetify, {VBtn, VIcon, VSnackbar} from 'vuetify/lib';
import Overlayable from 'vuetify/lib/mixins/overlayable';
import '@mdi/font/css/materialdesignicons.css'
import it from 'vuetify/es5/locale/it';
import en from 'vuetify/es5/locale/en';
import VuetifyToast from 'vuetify-toast-snackbar-ng';
import Ripple from 'vuetify/lib/directives/ripple';

if (Overlayable && Overlayable.options && Overlayable.options.methods && Overlayable.options.methods.shouldScroll) {
    Overlayable.options.methods.shouldScroll = function(el, e) {
        if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
        if (el.hasAttribute('data-app')) return false;

        const dir = e.shiftKey || e.deltaX ? 'x' : 'y';
        const delta = dir === 'y' ? e.deltaY : e.deltaX || e.deltaY;

        let alreadyAtStart;
        let alreadyAtEnd;
        if (dir === 'y') {
            alreadyAtStart = el.scrollTop === 0;
            alreadyAtEnd = el.scrollTop + el.clientHeight === el.scrollHeight;
        } else {
            alreadyAtStart = el.scrollLeft === 0;
            alreadyAtEnd = el.scrollLeft + el.clientWidth === el.scrollWidth;
        }

        const scrollingUp = delta < 0;
        const scrollingDown = delta > 0;

        if (!alreadyAtStart && scrollingUp) return true;
        if (!alreadyAtEnd && scrollingDown) return true;

        const parent = el.parentNode;
        if ((alreadyAtStart || alreadyAtEnd) && parent && parent.nodeType === Node.ELEMENT_NODE) {
            return this.shouldScroll(parent, e);
        }

        return false;
    };
}

Vue.use(Vuetify, {
    directives: {
        Ripple,
    },
    components: {
        VSnackbar,
        VBtn,
        VIcon
    }
});
Vue.use(VuetifyToast);
export default new Vuetify({
    lang: {
        locales: {it, en},
        current: 'it',
    }, icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    theme: {
        dark: document.documentElement.dataset.theme !== "light",
        themes: {
            light: {
                primary: '#128c90',
                secondary: '#795548',
                accent: '#ffeb3b',
                error: '#f44336',
                warning: '#ff9500',
                info: '#2196f3',
                success: '#4caf50',
                link: '#386ef3',
            },
            dark: {
                primary: '#128c90',
                secondary: '#795548',
                accent: '#ffeb3b',
                error: '#f44336',
                warning: '#ff9500',
                info: '#2196f3',
                success: '#4caf50',
                link: '#22d4f3',
            }
        }
    },
});
